import { MouseEvent } from "react";
import StyledButton, { ButtonSize, ButtonStyle } from "frontend/ui-components/styled-button";
import style from "./template-card.module.css";
import { Crown } from "frontend/icons/crown";

interface TemplateCardImageProps {
  thumbnailImageURL: string | null;
  templateName: string;
  previewAvailable: boolean;
  upgradeRequired: boolean;
  menuButtonRef: React.RefObject<HTMLDivElement>;
  shouldShowMenu: boolean;
  onPreviewClick: () => void;
  onMenuClick: (e: MouseEvent<HTMLDivElement>) => void;
}

export default function TemplateCardImage({
  thumbnailImageURL,
  templateName,
  previewAvailable,
  shouldShowMenu,
  upgradeRequired,
  menuButtonRef,
  onPreviewClick,
  onMenuClick,
}: TemplateCardImageProps) {
  return (
    <div className={style.templateImage} data-testid={`${templateName}-template-image-card`}>
      {thumbnailImageURL && <img src={thumbnailImageURL} alt={templateName} />}
      {upgradeRequired && (
        <div className={style.upgradeRequiredContainer}>
          <Crown size={10} />
        </div>
      )}
      {previewAvailable && (
        <div className={style.buttons}>
          <StyledButton
            title="Use Template"
            size={ButtonSize.small}
            style={ButtonStyle.filled}
            customStyle={{ width: 120, height: 26, fontWeight: 400, borderRadius: 6 }}
          />
          <span
            className={style.previewButton}
            onClick={(e) => {
              e.stopPropagation();
              onPreviewClick();
            }}
          >
            Preview
          </span>
        </div>
      )}
      {shouldShowMenu && (
        <div className={style.menuIcon} onClick={onMenuClick} ref={menuButtonRef} data-testid="template_menu" />
      )}
    </div>
  );
}
